import { jsx as _jsx } from "react/jsx-runtime";
import "./DeltaBadge.css";
export const DeltaBadge = ({ variant, label, size = "small", className, }) => {
    const classes = [
        "delta-badge",
        `delta-badge--${variant}`,
        `delta-badge--${size}`,
        className,
    ]
        .filter(Boolean)
        .join(" ");
    return _jsx("span", { className: classes, children: label });
};
//# sourceMappingURL=DeltaBadge.js.map